import '../vendor/jquery.tabSlideOut';

export const Layout = {
    initGlobalScripts() {
        this.initLazyLoad();
        this.initNavbar();
        this.initMatchHeight();
        this.initReturnToTop();
        this.initArticleProgressBar();
        this.initCrispChatBox();
        this.initBottomNewsletter();
        this.initPopoverNewsletter();
        this.initSidebarNewsletter();
        this.initCTANewsletters();
        this.initEmbeddedNewsletters();
        this.initVimeoPlayerOnModal();
    },

    initLazyLoad() {
        window.lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
        });
    },

    initNavbar() {
        /*menu burger to X*/
        $('.navbar-toggler').on('click', function () {
            $(this).toggleClass('collapsed');
            $('.navbar-mobile, .site-header__nav-mobile').toggleClass('fixed-top').toggleClass('sticky-top');
        });
    },

    initMatchHeight() {
        //box same height value
        $('.box-same-height').matchHeight();
        $('.box-same-height-hidden').matchHeight(false);
    },

    initReturnToTop() {
        $(window).scroll(function () {
            var $footer = $('#footer'),
                $returnToTop = $("#return-to-top"),
                $window = $(window),
                $document = $(document);

            //Return to Top Button
            if ($(this).scrollTop() >= 950) {
                $returnToTop.fadeIn();
            } else {
                $returnToTop.fadeOut();
            }

            if ($window.scrollTop() + $window.height() < $document.height() - $footer.height()) {
                $returnToTop.css("position", "fixed");
            }

            if ($window.scrollTop() + $window.height() > $document.height() - $footer.height()) {
                $returnToTop.css("position", "relative");
                $returnToTop.css("display", "inline-block");
            }
        });

        $("#return-to-top").click(function () {
            $("html, body").animate({
                scrollTop: 0
            }, 200, "linear");
        });
    },

    initArticleProgressBar() {
        $(window).scroll(function() {
            // calculate the percentage the user has scrolled down the page
           var $article = $('article.article-container').first(),
               scrollPercent;

           if ($article.length < 1) {
               $article = $('article.article').first();
           }

           if ($article.length < 1) {
               return;
           }

           scrollPercent = 100 * ($(window).scrollTop() - $article.offset().top) / ($article.height() - $(window).height());

            $('.rp-bar').css('width', scrollPercent +"%"  );
        });
    },

    /**
     * Smooth scroll to target element
     */ 
    slideToElement(selector, duration = 700)  {
        $('html,body').animate({
            scrollTop: $(selector).offset().top
        }, duration);
    },
    initCrispChatBox() {
        $(document).on('click', '.open-chat', function (e) {
            e.preventDefault();

            if (typeof $crisp !== 'undefined') {
                $crisp.push(["do", "chat:open"])
            }
        });
    },

    /**
     * Bottom newsletter
     *
     * @see app/views/v5/elements/layout/newsletter-popover.ctp
     */
    initBottomNewsletter() {
        let $wrapper = $('#bottom-newletter');
        if ($wrapper.length < 1 || $.cookie('SALEHOO[knownUser]') != undefined) {
            return;
        }

        //Show when a user has scrolled selected percent (%) of your page.
        let triggerPoint = 90;

        $wrapper.removeClass('d-none').tabSlideOut({
            tabLocation: 'bottom',
            offset: '60px',
            handleOffsetReverse: true,
            offsetReverse: true
        });

        let $form = $wrapper.find('form');
        this.initLeadForm($form, function (response) {
            $wrapper.find('a.handle .d-block').addClass('text-center').text('Successfully Subscribed');
            $wrapper.find('.handle-header').html('Check your email for updated newsletter.<br><br><br><br><br><br><br>');
            $form.addClass('d-none');
            $('#sidebar-newsletter').addClass('d-none');
            $('.cta-newsletter').addClass('d-none');
        });

        $(window).scroll(function () {
            if (($("body").height() * (triggerPoint / 100)) <= ($(window).height() + $(window).scrollTop())) {
                $("#bottom-newletter").css("visibility", "visible");
                $("#bottom-newletter").css("opacity", "1");
                $("#bottom-newletter").addClass("ui-slideouttab-open");
            } else {
                $("#bottom-newletter").removeClass("ui-slideouttab-open");
            }
        });
    },

    /**
     * Popover newsletter
     *
     * @see app/views/v5/elements/layout/newsletter-popover.ctp
     */
    initPopoverNewsletter() {
        let $wrapper = $('#popover-newsletter'),
            $modal = $('#modal-popover-newletter');
        if ($wrapper.length < 1 || $modal.length < 1 || $.cookie('SALEHOO[knownUser]') != undefined) {
            return;
        }

        let config = {
            name: '',
            onload: 0,
            onexit: 0,
            onfirst: 0,
            delay: 0,
            frequency: 0,
        }
        $.extend(config, $modal.data());

        if (typeof config.name != 'string' || config.name == '') {
            return;
        }

        let cookieName = config.name + 'Popover',
            firstCookie = cookieName + 'FVS',
            freqCookie = cookieName + 'FDL';

        config.onfirst = +config.onfirst;

        if (config.onfirst == 0) {
            if ($.cookie(firstCookie) == undefined) {
                $.cookie(firstCookie, 1, { expires: 365, path: '/' });
                return;
            }
        }

        config.frequency = +config.frequency;
        if (config.frequency > 0) {
            if ($.cookie(freqCookie) != undefined) {
                return;
            }
        }

        config.onload = +config.onload;
        config.onexit = +config.onexit;
        let delayTimeout, popoverShown = false, formInitiated = false;

        $modal.on('show.bs.modal', () => {
            popoverShown = true;
            clearTimeout(delayTimeout);
            if (config.frequency > 0) {
                if ($.cookie(freqCookie) == undefined) {
                    $.cookie(freqCookie, 1, { expires: config.frequency, path: '/' });
                }
            }
            if (formInitiated) {
                return;
            }
            formInitiated = true;
            $wrapper.removeClass('d-none');

            this.initLeadForm($wrapper.find('form'), function (response) {
                $wrapper.addClass('d-none');
                $('#popover-newsletter-success').removeClass('d-none');
                $('#sidebar-newsletter').addClass('d-none');
                $('#bottom-newletter').addClass('d-none');
                $('.cta-newsletter').addClass('d-none');
            });
        });

        if (config.onload) {
            let delay = +config.delay;
            if (delay > 0) {
                delayTimeout = setTimeout(() => {
                    if (popoverShown) {
                        return;
                    }
                    $modal.modal('show');
                }, delay * 1000);
            } else {
                if (!popoverShown) {
                    $modal.modal('show');
                }
            }
        }

        if (config.onexit) {
            let exit = () => {
                $(document).off('mouseleave',exit);
                if (popoverShown) {
                    return;
                }
                $modal.modal('show');
            };
            $(document).on('mouseleave',exit);
        }
    },

    /**
     * Sidebar newsletter
     *
     * @see app/views/v5/elements/sidebar/newsletter.ctp
     */
    initSidebarNewsletter() {
        const $wrapper = $('#sidebar-newsletter');

        if ($wrapper.length < 1 || $.cookie('SALEHOO[knownUser]') != undefined) {
            return;
        }

        const $toc = $('#toc-list'),
            $btn = $('#BtnTocCollapse');

        let formSubmitted = false,
            tocExpanded = false,
            collapseIsHidden = false,
            checkScroll = () => {
                if (!window.matchMedia('(min-width: 992px)').matches) {
                    return;
                }
                const scrollDepth = (window.scrollY / (document.body.offsetHeight - window.innerHeight)) * 100;
                if (scrollDepth > 30 && !collapseIsHidden) {
                    collapseIsHidden = true;
                } else if (scrollDepth <= 30 && collapseIsHidden) {
                    collapseIsHidden = false;
                }
                if (collapseIsHidden) {
                    if (!formSubmitted) {
                        $wrapper.removeClass('d-none');
                        if (!tocExpanded) {
                            $toc.collapse('hide');
                        }
                    }
                } else {
                    if (!formSubmitted) {
                        $wrapper.addClass('d-none');
                    }
                    $toc.collapse('show');
                }
            };

        checkScroll();

        this.initLeadForm($wrapper.find('form'), function (response) {
            $wrapper.addClass('d-none');
            $('#sidebar-newsletter-success').removeClass('d-none');
            $('#bottom-newletter').addClass('d-none');
            $('.cta-newsletter').addClass('d-none');
            formSubmitted = true;
        });

        $btn.on('click', () => {
            tocExpanded = !$btn.hasClass('collapsed');
        });

        $(window).scroll(checkScroll);
    },

    /**
     * @see php CtaHelper::renderForm() in app/views/helpers/cta.php
     */
    initCTANewsletters() {
        let $wrappers = $('.cta-newsletter');

        if ($wrappers.length < 1 || $.cookie('SALEHOO[knownUser]') != undefined) {
            return;
        }

        $wrappers.each((i) => {
            let $wrapper = $($wrappers[i]),
                $form = $wrapper.find('.cta-form'),
                $success = $wrapper.find('.cta-form-success');

            if ($form.length < 1) {
                return;
            }

            $wrapper.removeClass('d-none');

            this.initLeadForm($form.find('form'), function (response) {
                $form.addClass('d-none');
                $success.removeClass('d-none');
                $('#bottom-newletter').addClass('d-none');
                $('#sidebar-newsletter').addClass('d-none');
            });
        });
    },

    /**
     * @see app/views/v5/elements/layout/header-newsletter-signup-btn.ctp
     */
    initEmbeddedNewsletters() {
        let $wrappers = $('.embedded-newsletter');

        if ($wrappers.length < 1) {
            return;
        }

        let known = $.cookie('SALEHOO[knownUser]') != undefined;

        let $forms = $wrappers.find('.embedded-newsletter-form'),
            $successes = $wrappers.find('.embedded-newsletter-form-success')

        $wrappers.each((i) => {
            let $wrapper = $($wrappers[i]),
                persistSuccess = $wrapper.data('persist-success'),
                triggerLead = $wrapper.data('trigger-lead'),
                $form = $wrapper.find('.embedded-newsletter-form'),
                $success = $wrapper.find('.embedded-newsletter-form-success');

            if ($form.length < 1) {
                return;
            }

            if (+persistSuccess == 1 && known) {
                $form.addClass('d-none');
                $success.removeClass('d-none');
                $wrapper.removeClass('d-none');
                return;
            }

            $form.removeClass('d-none');
            $success.addClass('d-none');
            $wrapper.removeClass('d-none');

            let $ref = $form.find("input[name='data[Member][referral]']");
            if ($ref.val() === '') {
                $ref.val(document.location.href.replace(document.location.search, ''));
            }

            this.initLeadForm($form.find('form'), function (response) {
                $forms.addClass('d-none');
                $successes.removeClass('d-none');
                $('#bottom-newletter').addClass('d-none');
                $('#sidebar-newsletter').addClass('d-none');
                $('.cta-newsletter').addClass('d-none');
                $('#header-newsletter-signup-btn').addClass('d-none');
                $('#header-newsletter-signedup-btn').removeClass('d-none');
                if (triggerLead) {
                    SaleHoo.TrackedEvents.track('dl.leadSubmit');
                }
            });
        });
    },

    /**
     * Generic lead form control & validator
     *
     * @param form
     * @param success
     * @param error
     */
    initLeadForm(form, success, error)
    {
        let $form = $(form);
        $form.on('submit', function(e){
            e.preventDefault();
            $form.find('[type="submit"]').attr('disabled', true);
            $form.find('input.is-invalid').removeClass('is-invalid');
            $form.find('div.invalid-feedback').remove();
            let token = $form.find('input.csrf_client_token').val();
            $.ajax({
                type: 'POST',
                url: '/signup-submit/' + token,
                data: $form.serialize(),
                dataType: 'json'
            }).done((response) => {
                if (response.success) {
                    if (success != undefined) {
                        success(response);
                    }
                } else {
                    if (response.errors) {
                        let errors = response.errors, field;
                        for (field in errors) {
                            let $input = $form.find("input[name='data[Member]["+ field +"]']");
                            $input.addClass('is-invalid');
                            $input.after('<div class="invalid-feedback">' + errors[field] + '</div>');
                        }
                    }
                    if (error != undefined) {
                        error(response);
                    }
                }
            }).fail((jqXHR, textStatus, errorThrown) => {
                if (error != undefined) {
                    error(jqXHR, textStatus, errorThrown);
                }
            }).always(() => {
                $form.find('[type="submit"]').removeAttr('disabled');
            });
        });
    },

    initVimeoPlayerOnModal() {
        let $modal = $("#videoModal");
        if ($modal.length < 1) {
            return;
        }
        var player = null;
        $modal.on("show.bs.modal", function(){
            player = new Vimeo.Player("vimeo");
            player.play();
        }).on("hide.bs.modal", function(){
            if (player) {
                player.pause();
            }
        });
    }
}
